import { Component, Input } from '@angular/core';

@Component({
    selector: 'pp-notification-custom-field-mention',
    templateUrl: './notification-custom-field-mention.component.html',
    styleUrls: ['../notification.component.scss'],
    standalone: false
})
export class NotificationCustomFieldMentionComponent {
  @Input() ppLabel: string;

  constructor() {}
}
